import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  FixedDataPicker,
  IEnumPickerProps,
} from '@work4all/components/lib/components/entity-picker/fixed-data-picker/FixedDataPicker';

import { BzObjType } from '@work4all/models/lib/Enums/BzObjType.enum';

import { bzObjToEntityType } from '../../../../erp/components/simple-pdf-report/utils';

export interface BzObjTypePickerProps
  extends Omit<
    IEnumPickerProps<false>,
    'multiple' | 'clearable' | 'value' | 'onChange' | 'dataSet'
  > {
  value: BzObjType;
  onChange: (value: BzObjType) => void;
  disabledKeys?: BzObjType[];
}

type BzObjTypeItem = { id: BzObjType; name: string; label: string };

export function BzObjTypePicker(props: BzObjTypePickerProps) {
  const { value, onChange, disabledKeys = [], ...others } = props;
  const { t } = useTranslation();

  const dataSet = useMemo(
    () =>
      Object.keys(BzObjType)
        .filter((key) => !disabledKeys.includes(BzObjType[key]))
        .map((key) => {
          const name =
            key === BzObjType.UNKNOWN
              ? BzObjType.UNKNOWN
              : bzObjToEntityType[key];
          return {
            id: key,
            name: t(`COMMON.${name?.toUpperCase()}`),
            label: t(`COMMON.${name?.toUpperCase()}`),
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name)),
    [t, disabledKeys]
  );

  const valueBoxed = useMemo(
    () => dataSet.find((d) => d.id === value) ?? null,
    [dataSet, value]
  );

  const handleChange = (value: BzObjTypeItem) => {
    onChange(value ? value.id : null);
  };

  return (
    <FixedDataPicker
      value={valueBoxed}
      dataSet={dataSet}
      onChange={handleChange}
      multiple={false}
      clearable={false}
      {...others}
    />
  );
}
